import {Component, Inject, LOCALE_ID, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ProjectsService} from "../../shared/services/projects.service";
import {RegistrationsService} from "../../shared/services/registrations.service";
import {ToastrService} from "ngx-toastr";
import {CoreService} from "../../shared/services/core.service";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../environments/environment";
import {Subject, takeUntil} from "rxjs";
import {ThemesService} from "../../shared/services/themes.service";
import {FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {Project} from "../../shared/models/project.model";
import {isBoolean} from "ngx-bootstrap/chronos/utils/type-checks";
import {Registration} from "../../shared/models/registration.model";

interface firstSectionInterface {
  inputName: string,
  inputValue: string,
  inputType: string,
  inputRequired: boolean

}

@Component({
  selector: 'app-lead-generation',
  templateUrl: './lead-generation.component.html',
  styleUrls: ['./lead-generation.component.sass'],
  standalone: false
})
export class LeadGenerationComponent implements OnInit, OnChanges, OnDestroy {

  private ngUnsubscribe = new Subject<void>();
  public loading = true;
  public webServiceUrl = environment.spaUrl;

  public projectShortName: string | null = null;
  public partnerToken: string | null = null;
  public salutationValues: any[] = [];

  public telPrefixes = [
    '+43',
    '+49',
    '+31',
    '+36',
    '+385',
    '+386',
    '+39',
    '+41',
    '+420',
    '+421',
    '+48',
  ];

  public UxMessageSuccess = null;
  public UxMessageError = null;

  public emailValid = false;
  public emailVerificationValid = false;
  public firstSectionErrorMessage: string = '';
  public firstSectionShowErrorSubmitButton = false;
  public showFirstSection = true;
  public showSecondSection = false;

  private email: string = '';
  private emailVerification: string = '';

  public loadingRedirect = false;
  public enableAddress: boolean = false;
  public isSendSmsEnabled = false;

  public project: Project = new Project();

  private registration: Registration = new Registration();

  public dynamicFormGroup: FormGroup = new FormGroup({});
  public fields: any[] = [];

  private formModel = {
    Salutation: {
      type: 'dropdown',
      label: this.translateService.get('StepLeadGeneration.Salutation'),
      placeHolder: this.translateService.get('StepLeadGeneration.Salutation'),
      tooltipText: null,
      required: true,
      minLength: null,
      maxLength: null,
      value: ''
    },
    FirstName: {
      type: 'text',
      label: 'Vorname',
      placeHolder: 'Vorname',
      tooltipText: 'Bitte geben Sie Ihren Vornamen ein',
      required: true,
      minLength: 3,
      value: '',
    },
    LastName: {
      type: 'text',
      label: 'Nachname',
      placeHolder: 'Nachname',
      tooltipText: 'Bitte geben Sie Ihren Nachnamen ein',
      required: true,
      minLength: 3,
      value: ''
    },
    PhoneNumberPrefix: {
      type: 'dropdown',
      label: 'Vorwahl',
      placeHolder: 'Vorwahl',
      tooltipText: 'Bitte fügen Sie das Länderkennzeichen vor der Nummer an z.B. +43 oder 0043',
      required: true,
      minLength: 3,
      value: '+43'
    },
    phoneNumber: {
      type: 'text',
      label: 'Mobiltelefonnummer',
      placeHolder: 'Mobiltelefonnummer',
      tooltipText: 'Bitte geben Sie die Telefonnummer ohne Vorwahl ein',
      required: true,
      minLength: 3,
      maxLength: 20,
      value: '',
      validations: {
        pattern: '^[0-9]+$'
      }
    },
    Email: {
      type: 'email',
      label: 'Email',
      placeHolder: 'Email',
      tooltipText: 'Bitte geben Sie Ihre Emailaddresse ein',
      required: true,
      minLength: 3,
      validations: {
        pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
      },
      value: ''
    },
    EmailConfirmation: {
      type: 'email',
      label: 'Email überprüfen',
      placeHolder: 'Email überprüfen',
      tooltipText: 'Bitte geben Sie dieselbe Emailaddresse wie im Feld "Email" ein.',
      required: true,
      minLength: 3,
      validations: {
        pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'
      },
      value: ''
    },
    TOS: {
      type: 'checkbox',
      label: 'Ich stimme ausdrücklich zu, dass meine\n' +
        '  persönlichen Daten, also Name, Adresse, Telefonnummer, Email, Geburtsdatum sowie alle weiteren,\n' +
        '  Rechtsverfolgung meiner zum Nachweis der Ansprüche erforderlichen und/oder nützlichen sonstige \n' +
        '  Daten zum Zweck der Ansprüche verarbeitet werden. Diese Einwilligung kann ich jederzeit widerrufen.',
      value: '',
      required: true
    },
    Company: {
      type: 'text',
      label: 'Unternehmen',
      value: '',
      required: false
    },
    Street: {
      type: 'text',
      label: 'Straße',
      placeHolder: 'Straße',
      tooltipText: 'Bitte geben Sie Ihre Straße ein',
      required: false,
      minLength: 3,
      value: ''
    },
    Location: {
      type: 'text',
      label: 'Ort',
      placeHolder: 'Ort',
      tooltipText: 'Bitte geben Sie Ihren Ort ein',
      required: false,
      minLength: 3,
      value: ''
    },
    Zip: {
      type: 'text',
      label: 'PLZ',
      placeHolder: 'PLZ',
      tooltipText: 'Bitte geben Sie Ihre Postleitzahl ein',
      required: false,
      minLength: 3,
      value: ''
    },
    SendSms: {
      type: 'checkbox',
      label: this.translateService.get('StepLeadGeneration.SendSms'),
      required: false,
      value: false
    }
  };

  private salutationMale = '';
  private salutationFemale = '';
  private currentLanguage = 'de';
  public isEmailAlreadyRegistered = false;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectsService,
    private registrationService: RegistrationsService,
    private toastrService: ToastrService,
    private router: Router,
    public coreService: CoreService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private themeService: ThemesService
  ) {
    this.translateService.setDefaultLang('de');
    this.coreService.enableSidebar();
    this.coreService.disableThankYouPage();

    if (this.activatedRoute.snapshot.queryParams?.['lang']) {
      this.translateService.use(this.activatedRoute.snapshot.queryParams?.['lang']);
      this.currentLanguage = this.activatedRoute.snapshot.queryParams?.['lang'];
    }
    this.translateService.get('General.SuccessSubmit').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.UxMessageSuccess = res;
    });
    this.translateService.get('General.ErrorSubmit').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.UxMessageError = res;
    });
    this.translateService.get('General.ErrorCheckInput').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      this.firstSectionErrorMessage = res;
    });

    if (this.activatedRoute.snapshot.params['projectShortname']) {
      this.projectShortName = this.activatedRoute.snapshot.params['projectShortname'];

      // Sidebar / ThemeService nur mit der Projekt-Kurzbezeichnung versorgen.
      // Der eigentliche API-Call für die Sidebar findet zentral in der Sidebar-Komponente statt.
      this.themeService.setProjectShortName(this.projectShortName);
    } else {
      // ERROR
    }
  }

  ngOnInit(): void {
    //load current project
    this.projectShortName = this.activatedRoute.snapshot.paramMap.get('projectShortname');
    this.partnerToken = this.activatedRoute.snapshot.queryParamMap.get('partnerToken');
    if (this.projectShortName) {
      // Initialize form controls first
      this.initializeFormControls();
      this.getFormControlsFields();

      this.projectService.globalLoadingSignal.set(true);
      this.projectService.getProject(this.projectShortName).pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe({
          next: (project) => {
            this.themeService.checkThemeSettings(this.projectShortName);
            this.projectService.setLoading(true);

            this.translateService.get('StepLeadGeneration.Mister').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
              this.salutationMale = res;
              this.updateSalutationValues();
            });
            this.translateService.get('StepLeadGeneration.Miss').pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
              this.salutationFemale = res;
              this.updateSalutationValues();
            });

            this.project = project;
            // Set enableAddress based on project settings
            this.enableAddress = project.settings?.enableAddress || false;
            this.isSendSmsEnabled = project.settings?.sendSms === true;
            this.syncSendSmsControl();
            // Update form model with address fields based on enableAddress setting
            this.updateFormModelForAddress();
            this.coreService.enableIsLeadGenerationStep();
            this.coreService.disableGlobalLoading();
          },
          complete: () => {
            this.coreService.disableGlobalLoading();
          },
          error: (err) => {
            this.coreService.disableGlobalLoading();
            this.projectService.globalLoadingSignal.set(false);

            // Debug logging to understand the error structure
            console.error('Project loading error:', err);
            console.error('Error status:', err.status);
            console.error('Error message:', err.message);
            if (err.error) {
              console.error('Error details:', err.error);
            }

            // Check for specific API error response format
            // Handle different possible error structures
            const shouldRedirectTo404 =
              err.status === 404 ||
              (err.error && err.error.errorCode === 100100 && err.error.message === "Project not found") ||
              (err.error && err.error.errorCode === 100100) ||
              (err.message && err.message.includes("Project not found")) ||
              (err.error && err.error.message === "Project not found");

            if (shouldRedirectTo404) {
              this.router.navigate(['/404']);
            } else {
              this.toastrService.error(err);
            }
          }
        }
      );
    } else {
      this.coreService.disableGlobalLoading();
      this.projectService.globalLoadingSignal.set(false);
      this.router.navigate(['/404']);
    }
  }

  private initializeFormControls() {
    // Initialize the form group with essential controls including Salutation
    this.dynamicFormGroup = new FormGroup({
      Email: new FormControl('', [Validators.required, Validators.email, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      EmailConfirmation: new FormControl('', [Validators.required, Validators.email, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      Salutation: new FormControl('', [Validators.required])
    });

  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getFormControlsFields() {
    const formGroupFields = {};
    for (const field of Object.keys(this.formModel)) {
      if (field === 'SendSms' && !this.isSendSmsEnabled) {
        if (this.dynamicFormGroup.get(field)) {
          this.dynamicFormGroup.removeControl(field);
        }
        continue;
      }
      const fieldProps = this.formModel[field as keyof typeof this.formModel];
      this.fields.push(field as keyof typeof this.formModel);
      let validations = [];

      if (fieldProps['required' as keyof typeof fieldProps]) {
        if (fieldProps['type' as keyof typeof fieldProps] === 'checkbox') {
          validations.push(Validators.requiredTrue);
        } else {
          validations.push(Validators.required);
        }
      }

      // Special handling for address fields - they are required only when enableAddress is true
      if ((field === 'Street' || field === 'Location' || field === 'Zip') && this.enableAddress) {
        if (!validations.includes(Validators.required)) {
          validations.push(Validators.required);
        }
      }

      // Add email validation for email fields
      if (fieldProps['type' as keyof typeof fieldProps] === 'email') {
        validations.push(Validators.email);
        validations.push(Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'));
      }

      if (fieldProps['validations' as keyof typeof fieldProps]) {
        const validation = fieldProps['validations' as keyof typeof fieldProps];
        const pattern = String(validation['pattern' as keyof typeof validation]);
        if (pattern) {
          validations.push(Validators.pattern(pattern));
        }
      }

      if (fieldProps['minLength' as keyof typeof fieldProps]) {
        validations.push(Validators.minLength(parseInt(<string>fieldProps['minLength' as keyof typeof fieldProps])));
      }
      if (fieldProps['maxLength' as keyof typeof fieldProps]) {
        validations.push(Validators.maxLength(parseInt(<string>fieldProps['maxLength' as keyof typeof fieldProps])));
      }

      // Only add control if it doesn't exist to preserve existing values
      if (!this.dynamicFormGroup.get(field)) {
        this.dynamicFormGroup.addControl(
          field,
          new FormControl(
            fieldProps['value' as keyof typeof fieldProps],
            validations
          )
        );
      }
    }
    this.patchInitalValues();
    return formGroupFields;
  }

  patchInitalValues() {
    if (this.dynamicFormGroup.controls['PhoneNumberPrefix']) {
      this.dynamicFormGroup.controls['PhoneNumberPrefix'].patchValue('+43');
      this.dynamicFormGroup.controls['PhoneNumberPrefix'].markAsDirty();
      this.dynamicFormGroup.controls['PhoneNumberPrefix'].markAsTouched();
      this.dynamicFormGroup.controls['PhoneNumberPrefix'].setErrors(null);
    }
  }

  private updateSalutationValues() {
    if (this.salutationMale && this.salutationFemale) {
      this.salutationValues = [
        {index: 'Herr', name: this.salutationMale},
        {index: 'Frau', name: this.salutationFemale}
      ];
    }
  }

  private updateFormModelForAddress() {
    // Update address fields in formModel based on enableAddress setting
    this.formModel.Street.required = this.enableAddress;
    this.formModel.Location.required = this.enableAddress;
    this.formModel.Zip.required = this.enableAddress;
  }

  convertObjectToArray(theObject: Object) {
    return Object.keys(theObject).map(function (key) {
      return {
        key: key,
        value: theObject[key as keyof Object] as unknown as boolean[]
      };
    });
  }

  isSubmitPart1ButtonActive() {
    const email = this.dynamicFormGroup.controls['Email'].value?.toLowerCase() || '';
    const emailConfirmation = this.dynamicFormGroup.controls['EmailConfirmation'].value?.toLowerCase() || '';

    const emailValid = this.dynamicFormGroup.controls['Email'].valid &&
                      !this.dynamicFormGroup.controls['Email'].errors?.['email'] &&
                      !this.dynamicFormGroup.controls['Email'].errors?.['pattern'] &&
                      email.includes('@');
    const emailConfirmationValid = this.dynamicFormGroup.controls['EmailConfirmation'].valid &&
                                 !this.dynamicFormGroup.controls['EmailConfirmation'].errors?.['email'] &&
                                 !this.dynamicFormGroup.controls['EmailConfirmation'].errors?.['pattern'] &&
                                 emailConfirmation.includes('@');

    return emailValid && emailConfirmationValid && email === emailConfirmation;
  }

  private handleApiError(error: any) {
    if (error?.error?.code === '100130' || error?.error?.code === '100150') {
      this.isEmailAlreadyRegistered = true;
      this.firstSectionShowErrorSubmitButton = true;
      this.firstSectionErrorMessage = this.translateService.instant('General.ErrorAlreadyRegistered');
    } else {
      this.firstSectionShowErrorSubmitButton = true;
      this.firstSectionErrorMessage = this.translateService.instant('General.ErrorSubmit');
    }
  }

  onSubmitPart1(event: Event) {
    // Mark all fields as touched to show validation errors
    this.dynamicFormGroup.controls['Email'].markAsTouched();
    this.dynamicFormGroup.controls['EmailConfirmation'].markAsTouched();

    const email = this.dynamicFormGroup
      .controls['Email']
      .value
      .toLowerCase();
    const emailConfirmation = this.dynamicFormGroup
      .controls['EmailConfirmation']
      .value
      .toLowerCase();

    if ((email && emailConfirmation) && (email === emailConfirmation)) {
      this.showFirstSection = false;
      this.showSecondSection = true;
    }
  }

  onValueChanged(input: any, inputName: string) {
    if (inputName === 'Email') {
      this.email = this.dynamicFormGroup.controls[inputName].value?.toLowerCase() || '';
      this.emailValid = this.dynamicFormGroup.controls[inputName].valid &&
                       !this.dynamicFormGroup.controls[inputName].errors?.['email'] &&
                       !this.dynamicFormGroup.controls[inputName].errors?.['pattern'] &&
                       this.email.includes('@');
    }
    if (inputName === 'EmailConfirmation') {
      this.emailVerification = this.dynamicFormGroup.controls[inputName].value?.toLowerCase() || '';
      this.emailVerificationValid = this.dynamicFormGroup.controls[inputName].valid &&
                                  !this.dynamicFormGroup.controls[inputName].errors?.['email'] &&
                                  !this.dynamicFormGroup.controls[inputName].errors?.['pattern'] &&
                                  this.emailVerification.includes('@');
    }

    // Only check email mismatch if both fields have values and the user has finished typing
    if (this.email && this.emailVerification && this.emailVerification.length > 0) {
      if (this.email !== this.emailVerification) {
        this.dynamicFormGroup.controls['EmailConfirmation'].setErrors({'emailMismatch': true});
        this.dynamicFormGroup.controls['EmailConfirmation'].markAsTouched();
      } else {
        // Clear emailMismatch error if emails match
        const currentErrors = this.dynamicFormGroup.controls['EmailConfirmation'].errors;
        if (currentErrors && currentErrors['emailMismatch']) {
          delete currentErrors['emailMismatch'];
          if (Object.keys(currentErrors).length === 0) {
            this.dynamicFormGroup.controls['EmailConfirmation'].setErrors(null);
          } else {
            this.dynamicFormGroup.controls['EmailConfirmation'].setErrors(currentErrors);
          }
        }
      }
    }
  }

  onClickSubmitLeadGeneration() {
    if (this.dynamicFormGroup.valid && this.projectShortName !== null) {
      this.showSecondSection = false;
      this.showFirstSection = false;
      this.loadingRedirect = true;

      const formData = this.dynamicFormGroup.value;
      // Map form keys to lower-camel-case API keys
      const mappedFormData: any = {
        salutation: formData.Salutation,
        firstName: formData.FirstName,
        lastName: formData.LastName,
        phoneNumberPrefix: formData.PhoneNumberPrefix,
        phoneNumber: formData.phoneNumber,
        email: formData.Email,
        emailConfirmation: formData.EmailConfirmation,
        tos: formData.TOS,
        companyName: formData.Company,
        street: formData.Street,
        location: formData.Location,
        zip: formData.Zip
      };

      let requestData: any = {
        ...mappedFormData,
        ...(this.partnerToken && { partnerToken: this.partnerToken })
      };

      // Include root-level sendSms when the user grants consent
      if (formData.SendSms === true) {
        requestData = {
          ...requestData,
          sendSms: true
        };
      }

      this.registrationService.registerCustomer(
        requestData,
        this.projectShortName,
        this.currentLanguage
      ).pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe({
        next: (response: any) => {
          if(response.registrationSuccessful) {
            // If there's a partner token, always redirect to step 2
            if (this.partnerToken || this.project.settings?.redirectToStep2) {
              setTimeout(() => {
                const navigationExtras = this.partnerToken ? {
                  queryParams: { partnerToken: this.partnerToken }
                } : undefined;

                this.router.navigate([
                  'registration',
                  this.projectShortName?.toUpperCase(),
                  'step2',
                  response.tokenIdentifier
                ], navigationExtras).then();
              }, 10);
            } else {
              // Navigate to thank you page only if no partner token and redirectToStep2 is false
              setTimeout(() => {
                this.router.navigate([
                  'registration',
                  this.projectShortName?.toUpperCase(),
                  'thank-you-1'
                ]).then();
              }, 10);
            }
          } else {
            this.showSecondSection = true;
            this.loadingRedirect = false;
            if (response.errorCode) {
              this.translateService.get("FailureMessages." + response.errorCode.toString()).subscribe(message => {
                this.toastrService.error(message);
              });
            } else {
              this.toastrService.error('General.ErrorSubmit');
            }
          }
        },
        error: (error: any) => {
          this.showSecondSection = true;
          this.loadingRedirect = false;
          this.handleApiError(error);
        }
      });
    }
  }

  getFormValidationErrors() {

    let totalErrors = 0;

    Object.keys(this.dynamicFormGroup.controls).forEach(key => {
      const controlErrors: ValidationErrors | null | undefined = this.dynamicFormGroup?.get(key)?.errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
        });
      }
    });
  }

  clickOnBackButton() {
    this.showFirstSection = true;
    this.showSecondSection = false;
  }

  ngOnDestroy() {
    this.coreService.disableIsLeadGenerationStep();
  }

  getFormControl(fieldName: string): FormControl {
    if (!this.dynamicFormGroup) {
      this.dynamicFormGroup = new FormGroup({});
    }

    let control = this.dynamicFormGroup.get(fieldName) as FormControl;
    if (!control) {

      // Create a new control with appropriate validators based on the field name
      const validators = [];
      let initialValue = '';

      if (fieldName === 'Email' || fieldName === 'EmailConfirmation') {
        validators.push(
          Validators.required,
          Validators.email,
          Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
        );
      } else if (fieldName === 'Salutation') {
        validators.push(Validators.required);
        initialValue = ''; // Empty value to show placeholder
      } else if (fieldName === 'phoneNumber') {
        validators.push(Validators.required);
        validators.push(Validators.pattern('^[0-9]+$'));
        if (this.formModel.phoneNumber.minLength) {
          validators.push(Validators.minLength(this.formModel.phoneNumber.minLength));
        }
        if (this.formModel.phoneNumber.maxLength) {
          validators.push(Validators.maxLength(this.formModel.phoneNumber.maxLength));
        }
      } else if (fieldName === 'Street' || fieldName === 'Location' || fieldName === 'Zip') {
        // Address fields are required only when enableAddress is true
        if (this.enableAddress) {
          validators.push(Validators.required);
        }
        const fieldModel = this.formModel[fieldName as keyof typeof this.formModel];
        if (fieldModel && 'minLength' in fieldModel && fieldModel.minLength) {
          validators.push(Validators.minLength(fieldModel.minLength));
        }
      } else if (fieldName === 'SendSms') {
        // No validators needed for optional checkbox
      }

      control = new FormControl(initialValue, validators);
      this.dynamicFormGroup.addControl(fieldName, control);
          }
    return control;
  }

  getSalutationControl(): FormControl {
    return this.dynamicFormGroup.get('Salutation') as FormControl;
  }

  private syncSendSmsControl() {
    const existingControl = this.dynamicFormGroup.get('SendSms');
    if (this.isSendSmsEnabled) {
      if (!existingControl) {
        this.dynamicFormGroup.addControl('SendSms', new FormControl(false));
      }
    } else if (existingControl) {
      this.dynamicFormGroup.removeControl('SendSms');
    }
  }



  private handleError(error: any) {
    let message = 'General.ErrorOccurred';
    if (error.error?.message) {
      message = error.error.message;
    } else if (error.message) {
      message = error.message;
    }
    this.toastrService.error(message);
  }
}
